//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 领用明细
const collarDetailsList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/collarDetails/list.vue')),
    'collarDetailsList'
  );
// 新增领用明细
const collarAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/collarDetails/add.vue')),
    'collarAdd'
  );
// 领用明细详情
const collarDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/collarDetails/details.vue')),
    'collarDetails'
  );

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'collarDetailsList',
      name: 'collarDetailsList',
      component: collarDetailsList,
      meta: {
        keepAlive: true,
        title: '领用明细',
      },
    },
    {
      path: 'collarAdd',
      name: 'collarAdd',
      component: collarAdd,
      meta: {
        keepAlive: true,
        title: '新增领用明细',
      },
    },
    {
      path: 'collarDetails',
      name: 'collarDetails',
      component: collarDetails,
      meta: {
        keepAlive: true,
        title: '领用明细详情',
      },
    },
  ],
};
export default productionRouter;
